import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { FwDialogContentComponent, FwDialogSimpleComponent } from '@flywheel-io/vision';

@Component({
  host: {
    'test-id': 'error-dialog',
  },
  selector: 'error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  imports: [FwDialogContentComponent, FwDialogSimpleComponent],
})
export class ErrorDialog {
  protected data = inject<{
    contentText: string;
    title: string;
    cancelButtonText: string;
  }>(DIALOG_DATA);
}
